import { ResponsibleApi } from '@atlas/core';

import { isSelfRegulationOlderThanYear } from './utils';

const resolveSelfRegulationPopupVisibility = async (account, authenticated) => {
  if (!authenticated) return false;

  const data = await ResponsibleApi.getRealityCheckSettings();

  return account.realityCheckConfigurationEnabled && isSelfRegulationOlderThanYear(data);
};

export default resolveSelfRegulationPopupVisibility;
